module.exports = __webpack_public_path__ + "static/img/cont3101.f53630f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3101.jpg
// module id = HYQm
// module chunks = 0